import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConstructionHouse = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "construction-house" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.25,20.105h-6a1.5,1.5,0,0,1-1.5-1.5V9.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,8.25l9.531-7.145a1.5,1.5,0,0,1,1.938,0L21.75,8.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.25,20.105V16.053a1.5,1.5,0,0,1,1.5-1.5h1.5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 11.25,
			cy: 7.5,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18,
			y1: 15.75,
			x2: 18,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,15.75H16.5a2.244,2.244,0,0,0-1.572,1.1.376.376,0,0,1-.678-.222V15a3,3,0,0,1,3-3h3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.75,11.25h2.5a0,0,0,0,1,0,0V16.5a0,0,0,0,1,0,0h-2.5a.5.5,0,0,1-.5-.5V11.75A.5.5,0,0,1,20.75,11.25Z"
		})
	]
});
export default SvgConstructionHouse;
